import React, { useEffect, useRef, useState } from 'react';
import { NumericFormat } from 'react-number-format';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import Translate from '../../utils/Translate';
import getUid from '../../utils/getUid';
import { InputBaseComponentProps } from '@mui/material/InputBase/InputBase';
import { CustomNumberFormat } from '../Search/SearchNumberField';

export interface INumberFieldProps {
    className?: string;

    label: string;
    id?: string;
    onChange: (name: string, value: number) => void;
    onBlur?: (ev?: React.FormEvent) => void;
    name: string;
    value: string | number;
    thousandSeparator?: string;
    decimalSeparator?: string;
    decimalScale?: number;
    disabled?: boolean;
    suffix?: string;
    prefix?: string;
    allowEmptyFormatting?: boolean;
    autoFocus?: boolean;
    inputMode?:  InputBaseComponentProps['inputMode'];
    error?: boolean;
    helperText?: string;
    autocomplete?: 'on' | 'off' | 'new-password' | string | boolean;
    customInput?: React.ReactNode;
    inputProps?: TextFieldProps['inputProps'];
    // children: React.ReactNode;
    fixedDecimalScale?: boolean;

    variant?: TextFieldProps['variant'];
}

const NumberField: React.FC<React.PropsWithChildren<INumberFieldProps>> = (props) => {

    const {
        id = null,
        name = '',
        value = '',
        onChange = () => { },
        thousandSeparator = '.',
        decimalSeparator = ',',
        decimalScale = 2,
        suffix,
        prefix,
        autoFocus = false,
        allowEmptyFormatting = true,
        label = '',
        className = '',
        inputMode = 'decimal' as InputBaseComponentProps['inputMode'],
        error = false,
        helperText = '',
        autocomplete,
        customInput,
        inputProps,
        fixedDecimalScale,
        ...other
    } = props;

    const [uid] = useState(id ? id : getUid('numberfield' + name));
    const inputRef = useRef<HTMLInputElement>();

    const currValue = `${value}`;

    const onFocus = () => {
        const elm = inputRef.current;
        elm.selectionStart = 0;
        elm.selectionEnd = Translate.getNumber(parseFloat(currValue))?.length || 0;
    };

    return (
        <CustomNumberFormat
            {...other}
            name={name}
            value={currValue}
            customInput={TextField}
            label={label}
            fullWidth
            inputProps={{
                style: { textAlign: 'right' },
                inputMode: inputMode,
                autoComplete: autocomplete === false ? 'off' : typeof autocomplete === 'string' ? autocomplete : null,
            }}
            inputRef={inputRef}
            id={uid}
            decimalScale={decimalScale}
            // fixedDecimalScale={decimalScale && parseFloat(currValue) > 0 && Translate.parseInt(currValue) !== Translate.parseFloat(currValue)}
            onValueChange={(values) => {
                onChange(name, values.floatValue);
            }}
            displayType={'input'}
            thousandSeparator={thousandSeparator}
            decimalSeparator={decimalSeparator}
            disabled={false}
            suffix={suffix ? suffix : undefined}
            prefix={prefix ? prefix : undefined}
            allowEmptyFormatting={allowEmptyFormatting}
            allowLeadingZeros={false}
            autoFocus={autoFocus}
            error={error}
            helperText={helperText}
            onFocus={onFocus}
            fixedDecimalScale={fixedDecimalScale}
        />
    );
};

export default NumberField;
